<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Servicios - {{this.siniestroSeleccionado}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-tab-group #servicios (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="true" mat-align-tabs="center"
    color="primary">
    @for (opcion of catTabsServicios ; track opcion) {
      <mat-tab [label]="opcion">
        <ng-template mat-tab-label>
          {{opcion.nombre}}
        </ng-template>
        <div class="contenedor-panel">
          @switch (opcion.id) {
            @case (1) {
              <app-crear-actualizar-servicios-asegurado [datosServiciosAsegurados]="datosServicios.Asegurados" (eventosServiciosAsegurado)="procesarEventosServicios($event)"></app-crear-actualizar-servicios-asegurado>
            }
            @case (2) {
              <app-crear-actualizar-servicios-tercero [datosServiciosTerceros]="datosServicios.Terceros" (eventosServiciosTercero)="procesarEventosServicios($event)"></app-crear-actualizar-servicios-tercero>
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>